export const hardcodedUserIdsForLibSampleCode = [
    { name: "undefined", id: undefined, enabled: true },
    { name: "studentA", id: "studentA", enabled: false },
    { name: "studentB", id: "studentB", enabled: false },
    { name: "studentC", id: "studentC", enabled: false },
    { name: "teacherA", id: "teacherA", enabled: false },
    { name: "teacherB", id: "teacherB", enabled: false },
];
//# sourceMappingURL=const.js.map